import React, { useState } from 'react';
import { WithInsightType, IHighlight } from './types';
import scrollIntoView from 'scroll-into-view';
import { throttle } from 'lodash';
import { useGlobalEventListener } from 'hooks/useGlobalEventListener';
import { isServer } from 'utils';
import { ProgressWrapper, ProgressIndicator } from './styled';

export interface ProgressIndicatorProps extends WithInsightType {
  isActive: boolean;
  progress: number;
}

const MIN_PROGRESS_VALUE = .15;

interface ProgressBarProps {
  outerRef: React.RefObject<HTMLDivElement>;
  activeHighlightIndex: number;
  highlights: IHighlight[];
}

export const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({ outerRef, activeHighlightIndex, highlights }) => {
  const [ progress, setProgress ] = useState(MIN_PROGRESS_VALUE);

  const getHighlightsEls = () => outerRef.current && outerRef.current.children[0].children;

  const onProgress = () => {
    const el = (getHighlightsEls()[activeHighlightIndex] as HTMLElement);
    const viewThreshold = window.scrollY + window.innerHeight;
    const nextProgress = ((viewThreshold - el.offsetTop) / (el.clientHeight / 100)) / 100;
    setProgress(nextProgress > MIN_PROGRESS_VALUE ? nextProgress : MIN_PROGRESS_VALUE);
  };

  useGlobalEventListener(isServer() ? null : window, 'scroll', throttle(onProgress, 100, { trailing: true }));
  useGlobalEventListener(isServer() ? null : window, 'resize', throttle(onProgress, 100, { trailing: true }));

  const jumpToHighlight = (nextIndex: number) => () => {
    scrollIntoView((getHighlightsEls()[nextIndex] as HTMLElement), {
      align: {
        top: 0,
      },
    });
  };

  return (
    <ProgressWrapper data-auto="mobile-opened-tradeoffs-progress-bar">
      {highlights.map((highlight, id) => (
        <ProgressIndicator
          data-auto="progress-item"
          data-auto-is-active={activeHighlightIndex === id}
          onClick={jumpToHighlight(id)}
          key={highlight.previewText + id}
          insightType={highlight.type}
          isActive={activeHighlightIndex === id}
          progress={progress}
        />
      ))}
    </ProgressWrapper>
  );
};
